import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";
import { API, graphqlOperation } from "aws-amplify";

interface FavoriteTenderProps {
  tenderId: string;
  companyID?: string;
  initialFavorite?: boolean;
  className?: string;
}

export const FavoriteTender = ({
  tenderId,
  companyID = "",
  initialFavorite = false,
  className = ""
}: FavoriteTenderProps) => {
  const [favorited, setFavorite] = useState(initialFavorite);

  const createFavoriteQuery = `mutation MyMutation { createCompanyTender(input: {id: "${companyID}_${tenderId}", companyId: "${companyID}", tenderId: "${tenderId}"}) { id } }`;
  const deleteFavoriteQuery = `mutation MyMutation { deleteCompanyTender(input: {id: "${companyID}_${tenderId}"}) { id } }`;

  async function handleFavorite(e: React.MouseEvent) {
    e.stopPropagation();
    
    if (!favorited) {
      try {
        await API.graphql(graphqlOperation(createFavoriteQuery));
        setFavorite(true);
      } catch (err) {
        console.log(err);
      }
    } else {
      try {
        await API.graphql(graphqlOperation(deleteFavoriteQuery));
        setFavorite(false);
      } catch (err) {
        console.log(err);
      }
    }
  }

  return (
    <div
      className={clsx("z-1", className)}
      onClick={handleFavorite}
    >
      <FontAwesomeIcon
        className={clsx(
          "text-2xl",
          favorited
            ? "text-primary-pink"
            : "text-gray-300 hover:text-primary-pink"
        )}
        icon="heart"
      />
    </div>
  );
};
